import { combineReducers } from "redux"
import { combineEpics } from "redux-observable"
import { InventoryConfigurationEpics } from "./configuration/epics"
import { InventoryStockDocumentDefinitionReducer } from "./stockDocumentDefinition"
import { InventoryStockDocumentDefinitionEpics } from "./stockDocumentDefinition"
import { InventoryConfigurationReducer } from "./configuration/reducers"
import { InventoryLocationEpics } from "./location/epics"
import { StockLocationReducer } from "./location/reducers"
import { StockDocumentReducer } from "./stockdocument/reducers"
import { StockDocumentEpics } from "./stockdocument/epics"
import { InventoryDataEpics } from "./data/epics"

export const combinedReducers = combineReducers({
    configuration: InventoryConfigurationReducer,
    stockDocumentConfiguration: InventoryStockDocumentDefinitionReducer,
    stockDocument: StockDocumentReducer,
    stockLocation: StockLocationReducer,
})

export const combinedEpics = combineEpics(
    InventoryStockDocumentDefinitionEpics,
    InventoryConfigurationEpics,
    StockDocumentEpics,
    InventoryLocationEpics,
    InventoryDataEpics
)


// WEBPACK FOOTER //
// ./src/state/inventory/rootReducer.ts